var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMidnight = function SvgMidnight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    className: "icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FA870B",
    d: "M527.155 952.32c-125.686 0-232.93-44.493-321.976-133.56C116.152 729.65 71.68 622.264 71.68 496.61c0-90.42 25.539-174.111 76.513-251.475 51.118-77.26 117.863-134.174 200.295-170.926 5.181-3.963 10.475-3.246 15.667 1.946 6.523 3.963 8.55 9.78 5.908 17.715-20.869 49.869-31.365 100.168-31.365 151.276 0 116.582 41.575 216.402 124.723 299.581 83.108 83.17 182.887 124.764 299.398 124.764 64.102 0 119.777-9.779 166.901-29.43 5.192-4.034 10.384-3.358 15.596 1.833 6.492 3.984 8.53 9.8 5.867 17.716-33.976 89.088-89.282 160.102-165.908 213.145-76.524 53.043-162.58 79.565-258.12 79.565"
  })));
};
export { SvgMidnight as ReactComponent };
export default __webpack_public_path__ + "af1bb6cdf3be9c901c334b0fe4162c11.svg";